var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":"Delete Activity","button-text":'Delete',"button-type":'danger',"button-status":_vm.deleting,"show":_vm.setShow},on:{"update:show":function($event){_vm.setShow=$event},"confirm":_vm.deleteBadge}},[_c('p',[_vm._v(" This action cannot be undone. Are you sure you want to delete this activity? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }